import type { ToolAccess } from "@/lib/api";

/** A small label in a cell, like the role on the users table. */
export const CHIP = "inline-block rounded-sm px-2 py-0.5 text-xs font-medium whitespace-nowrap";

/**
 * The keyboard focus of a chip that is focusable for its tooltip: an outline
 * 2 px outside it, so it shows on a chip in the ring's own colour (a solid
 * blue one) and leaves a chip's own inset line alone.
 */
export const CHIP_FOCUS =
  "focus-visible:outline-ring focus-visible:outline-2 focus-visible:outline-offset-2";

/**
 * A chip's colours, by what it says:
 * - `read` and `write`: reading in De Ceuster's light blue tint, writing in
 *   solid De Ceuster blue (also an admin's role, in the light tint);
 * - `neutral`: a category without weight, in light grey (a team, a role);
 * - `soon`: not there yet, a dashed outline;
 * - `danger`: something that stops someone, such as a block.
 */
export const CHIP_TONE = {
  read: "bg-accent-light text-primary",
  write: "bg-primary text-primary-foreground",
  neutral: "bg-muted/15 text-muted-foreground",
  soon: "border-border text-muted border border-dashed",
  danger: "bg-destructive/10 text-destructive",
} as const;

export type ChipTone = keyof typeof CHIP_TONE;

/** Reading in De Ceuster's light blue tint, writing in solid De Ceuster blue. */
export const ACCESS_CHIP: Record<ToolAccess, string> = {
  read: CHIP_TONE.read,
  write: CHIP_TONE.write,
};
